export default "__VITE_ASSET__831eb939__"